(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_countdown"] && !Shopify.designMode) return;
  try {
    (function () {
    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function init(el) {
      if (el.dataset.cdReady === 'true') { return; }
      el.dataset.cdReady = 'true';

      var target = new Date(el.getAttribute('data-opening')).getTime();
      if (isNaN(target)) { return; }

      var d = el.querySelector('[data-cd-days]');
      var h = el.querySelector('[data-cd-hours]');
      var m = el.querySelector('[data-cd-minutes]');
      var s = el.querySelector('[data-cd-seconds]');

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          d.textContent = h.textContent = m.textContent = s.textContent = '00';
          clearInterval(timer);
          return;
        }
        d.textContent = pad(Math.floor(diff / 86400000));
        h.textContent = pad(Math.floor((diff % 86400000) / 3600000));
        m.textContent = pad(Math.floor((diff % 3600000) / 60000));
        s.textContent = pad(Math.floor((diff % 60000) / 1000));
      }

      tick();
      var timer = setInterval(tick, 1000);
    }

    function initAll() {
      document.querySelectorAll('[data-password-countdown]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Re-init when the section is re-rendered in the theme editor
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
